<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li>Questões</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" v-canaccess="'/questao/create'" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Questões</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="disciplinaId">Disciplina</label>
                                    <select v-select="{ dataitem: 'AuxDisciplina', default: 'Todos' }" v-model="filter.disciplinaId" class="form-control" name="disciplinaId"></select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="dificuldadeId">Dificuldade</label>
                                    <select v-select="{ dataitem: 'AuxDificuldade', default: 'Todos' }" v-model="filter.dificuldadeId" class="form-control" name="dificuldadeId"></select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="tipoRespostaId">Tipo da Resposta</label>
                                    <select v-select="{ dataitem: 'AuxTipoResposta', default: 'Todos' }" v-model="filter.tipoRespostaId" class="form-control" name="tipoRespostaId"></select>
                                </div>

                                <div class="form-group col-md-8">
                                    <label for="enunciado">Enunciado</label>
                                    <input type="text" class="form-control" name="enunciado" placeholder="Enunciado" v-model="filter.enunciado" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label>Ativo?</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.ehAtivo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.ehAtivo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.ehAtivo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Disciplina <i @click="executeOrderBy('disciplina.nome')" class="fa fa-sort"></i></th>
                                    <th>Enunciado <i @click="executeOrderBy('enunciado')" class="fa fa-sort"></i></th>
                                    <th>Dificuldade <i @click="executeOrderBy('dificuldade.nome')" class="fa fa-sort"></i></th>
                                    <th>Tipo da Resposta <i @click="executeOrderBy('tipoResposta.nome')" class="fa fa-sort"></i></th>
                                    <th>Tags</th>
                                    <th>Perguntas</th>
                                    <th>Ativo? <i @click="executeOrderBy('ehativo')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.questaoId" class="animated fadeIn">
                                    <td>{{ item.questaoId }}</td>
                                    <td>{{ item.disciplina.nome }}</td>
                                    <td class="text-ellipsis">
                                        <div v-html="item.enunciadoFormatado" v-b-tooltip.html.right :title="item.enunciadoFormatado"></div>
                                    </td>
                                    <td>{{ item.dificuldade.nome }}</td>
                                    <td>{{ item.tipoResposta.nome }}</td>
                                    <td>
                                        <ul class="list-unstyled">
                                            <li v-for="tag in item.collectionQuestaoTagJobs" v-bind:key="item.tagJobsId">{{tag.tagJobs.nome}} </li>
                                        </ul>
                                    </td>
                                    <td><span class="badge badge-pill badge-secondary">{{ item.totalPerguntas }}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ehAtivo, 'badge-danger': !item.ehAtivo }">{{item.ehAtivo ? 'Sim' : 'Não'}}</span></td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" v-canaccess="'/questao/edit'" v-b-tooltip title="Editar" @click="openEdit({ questaoId: item.questaoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" v-canaccess="'/questao/delete'" v-b-tooltip title="Remover" @click="openRemove({ questaoId: item.questaoId, collectionQuestaoPergunta: item.collectionQuestaoPergunta })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="questaoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <br />
            <p>Se essa questão estiver atrelada a algum teste, ela será inativada</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'questao',
        mixins: [base],
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'questao',
                    remove: 'questao'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,

                    disciplinaId: "",
                    tipoRespostaId: "",
                    enunciado: "",
                    dificuldadeId: ""
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.$router.push({ path: '/questao/edit/' + model.questaoId });
            },
            openCreate: function () {
                this.$router.push({ path: '/questao/create' });
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    if (this.model.collectionQuestaoPergunta.length > 0)
                        this.defaultSuccessResult("Item inativado com sucesso");
                    else
                        this.defaultSuccessResult("Item excluído com sucesso");

                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {

                this.showLoading();

                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    data.dataList = data.dataList.map(item => {
                        item.enunciadoFormatado = item.enunciado.replace(/<[^>]*>/g, '');
                        return item;
                    });
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>